import { type Observable } from '@legendapp/state';
import { createPersistedStore } from '@kidslabs/module-core';
import { type CartItemInterface, type Maybe } from '../types/front.graphql';

export type CheckoutCartStore = {
    id: string;
    items: Maybe<Array<Maybe<CartItemInterface>>>;
};

const initialState: CheckoutCartStore = {
    id: '',
    items: [],
};

/**
 * Checkout cart observable store with automatic IndexedDB persistence
 *
 * ✅ Auto-registers as 'checkoutCart'
 * ✅ No manual SSR checks needed
 * ✅ Automatic persistence on client-side
 */
export const checkoutCartStore$: Observable<CheckoutCartStore> = createPersistedStore<CheckoutCartStore>(
    'checkoutCart',
    initialState
);
